export const GET_TAGS = "GET_TAGS";
export const INSERT_TAGS = "INSERT_TAGS";
export const UPDATE_TAGS = "UPDATE_TAGS";
export const DELETE_TAGS = "DELETE_TAGS";

export const OPEN_TAGS_DIALOG = "OPEN_TAGS_DIALOG";
export const CLOSE_DIALOG = "CLOSE_DIALOG";

export const OPEN_TAGS_TOAST = "OPEN_TAGS_TOAST";
export const CLOSE_TAGS_TOAST = "CLOSE_TAGS_TOAST";